import { PcsDetailType } from "../interface";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useSavePurchaseOrder } from "../hooks/useSavePurchaseOrder";
import { SearchContactsInner } from "../../../../../components/common/modal/inner/SearchContactsInner";
import { useModal } from "../../../../../hooks";
import SearchAddressInner from "../../../../../components/common/modal/inner/SearchAddressInner";
import { useQueryClient } from "@tanstack/react-query";
import { useReadShippingSelectBox } from "../../../../order/orders/create/hooks/useReadShippingSelectBox";
import { useReadPaymentSelectBox } from "../../../../order/orders/create/hooks/useReadPaymentSelectBox";
import { SearchBusinessPartnerInner } from "../../../../../components/common/modal/inner/SearchBusinessPartnerInner";
import useSetPurchaseValue from "../hooks/useSetPurchaseValue";
import { useUser } from "../../../../../util/userContext/UserContext";
import DaumPost from "../../../../../components/common/DaumPost"; // 내부수정: 신규 주소

interface PropsType {
    pcsDetail: PcsDetailType
    setIsModify: Dispatch<SetStateAction<boolean>>
    modifyTrigger: boolean
    setModifyTrigger: Dispatch<SetStateAction<boolean>>
    menuTitleText: string
    isPcsDelivery?: boolean
}

export default function Tab1Modify({
    pcsDetail,
    setIsModify,
    modifyTrigger,
    setModifyTrigger,
    menuTitleText,
    isPcsDelivery
}: PropsType) {
    const { handleModal } = useModal();
    const qc = useQueryClient()


    const { user } = useUser();

    const { mutateAsync: mutateAsyncSavePurchaseOrder } = useSavePurchaseOrder()

    const { data: shipmentList } = useReadShippingSelectBox()
    const { data: paymentList } = useReadPaymentSelectBox()

    const { register, handleSubmit, getValues, control, setValue, watch } = useForm({
        defaultValues: pcsDetail,
    });

    const watchUpdateData = {
        ...pcsDetail,
        ...useWatch<PcsDetailType>({ control }),
    } as PcsDetailType;

    const { setContact, setAccount } = useSetPurchaseValue()

    // NOTE: 수신자(_new_l_recipient_value), 계산서담당자(newLInvoiceAgentValue), 수주고객(newLContactValue) 선택 모달
    const btnSearchRecipient = (key: "newLRecipientValue" | "newLInvoiceAgentValue" | "newLContactValue") => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchContactsInner
                    confirmCallback={(item) => {
                        setValue(key, item.contactId)

                        if (key === "newLRecipientValue") {
                            setValue("recipientName", item.fullName)
                            setValue("recipientMobile", item.mobilePhone)
                        } else if (key === "newLInvoiceAgentValue") {
                            setValue("taxCharge", item.fullName)
                            setValue("taxMobile", item.mobilePhone)
                            setValue("taxEmail", item.emailAddress1)
                        } else if (key === "newLContactValue") {
                            setContact(item, setValue)
                        }
                    }}
                    modalDepth={1}
                    args={user ? {userId: user.userId} : null}
                />
            ),
            type: "",
            title: "연락처 조회",
            modalSize: "xxl",
        })
    }

    // NOTE: 발송지 선택 모달
    const btnSearchAddress = () => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchAddressInner
                    confirmCallback={(item) => {
                        if (setValue) {
                            setValue("newLAddressValue", item?.new_addressid);
                            setValue("addressName", item?.newName);
                            setValue("address1", item?.new_txt_line1);
                            setValue("address2", item?.new_txt_line2);
                            // 내부수정: 신규 주소 초기화
                            setValue("customPostcode", "");
                            setValue("customAddress1", "");
                            setValue("customAddress2", "");
                        }
                    }}
                    modalDepth={1}
                    args={user ? {userId: user.userId} : null}
                />
            ),
            type: "",
            title: "주소 조회",
            modalSize: "xxl",
        })
    }

    // NOTE: 고객사 선택 모달
    const btnSearchAccount = () => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchBusinessPartnerInner
                    confirmCallback={(item) => {
                        setAccount(item, setValue)
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: "고객사 조회",
            modalSize: "xxl",
        })
    }

    const saveCallback = (submitData: PcsDetailType) => {
        if (!submitData.newLEnduserValue || submitData.newLEnduserValue === "") {
            handleModal({
                isOpen: true,
                contents: "고객사를 선택해주세요.",
                type: "alert",
            })
        } else if (!submitData.newLContactValue || submitData.newLContactValue === "") {
            handleModal({
                isOpen: true,
                contents: "수주고객을 선택해주세요.",
                type: "alert",
            })
        } else if (!submitData.newDtRequestShipment || submitData.newDtRequestShipment === "") {
            handleModal({
                isOpen: true,
                contents: "발송요청일을 입력해주세요.",
                type: "alert",
            })
        } else if (!submitData.newLRecipientValue || submitData.newLRecipientValue === "") {
            handleModal({
                isOpen: true,
                contents: "수신자를 선택해주세요.",
                type: "alert",
            })
        }
        // else if (!submitData.newLAddressValue || submitData.newLAddressValue === "") {
        //     handleModal({
        //         isOpen: true,
        //         contents: "발송지를 선택해주세요.",
        //         type: "alert",
        //     })
        // }
        // else if (!submitData.newDtEstimatedCollection || submitData.newDtEstimatedCollection === "") {
        //     handleModal({
        //         isOpen: true,
        //         contents: "수금예정일을 입력해주세요.",
        //         type: "alert",
        //     })
        // }
        // else if (!submitData.newPPayment || submitData.newPPayment === 0) {
        //     handleModal({
        //         isOpen: true,
        //         contents: "결제방법을 선택해주세요.",
        //         type: "alert",
        //     })
        // }
        else if (!submitData.newLInvoiceAgentValue || submitData.newLInvoiceAgentValue === "") {
            handleModal({
                isOpen: true,
                contents: "계산서 담당자를 선택해주세요.",
                type: "alert",
            })
        } else {
            mutateAsyncSavePurchaseOrder(submitData).then(res => {
                if (res.data.code === "0000") {
                    handleModal({
                        isOpen: true,
                        contents: "저장되었습니다.",
                        type: "alert",
                        closeAction: () => {
                            qc.invalidateQueries({ queryKey: ["readPurchaseOrderDetail"] })
                            setIsModify(false)
                        }
                    });
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    };

    const btnSearchTransfer = () => {
        if (pcsDetail?.invoiceNo?.length !== 13) {
            handleModal({
                isOpen: true,
                contents: "올바르지 않은 송장번호입니다.",
                type: "alert"
            })
            setValue("invoiceNo", "");
        } else {
            window.open(`https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${pcsDetail.invoiceNo}&displayHeader=`, "_blank", "noopener,noreferrer")
        }
    }

    useEffect(() => {
        if (modifyTrigger) {
            saveCallback(watchUpdateData)
            setModifyTrigger(false)
        }
    }, [modifyTrigger]);

    return <div className="content_wrap">
        <h5 className="subheading mt-0">{menuTitleText}정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                    <tr>
                        {/* 내부수정: 수주고객 고객사 자리 변경, 컬럼명 수정 */}
                        <th>성명 <span className="required">*</span></th>
                        <td className="p-4px">
                            <div className="d-flex">
                                <input type="text" className="form-control"
                                    value={watchUpdateData.contactName}
                                    disabled />
                                <button
                                    className="btn btn-info btn_search w-100px ms-5px"
                                    onClick={() => btnSearchRecipient("newLContactValue")}
                                    disabled={Number(user?.inOutFlag) === 1}
                                    >
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                        alt=""
                                    />찾기
                                </button>
                            </div>
                        </td>
                        <th>회사명 <span className="required">*</span></th>
                        <td className="p-4px">
                            <div className="d-flex">
                                <input type="text" className="form-control"
                                    value={watchUpdateData.enduserName}
                                    disabled />
                                <button
                                    className="btn btn-info btn_search w-100px ms-5px"
                                    onClick={btnSearchAccount}
                                    disabled={Number(user?.inOutFlag) === 1}>
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                        alt=""
                                    />찾기
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th style={{ width: "16.66%" }}>납품희망일 <span className="required">*</span></th>
                        <td style={{ width: "33.34%" }} className="p-4px">
                            <input type="date"
                                className="form-control"
                                max="9999-12-31"
                                value={watchUpdateData.newDtRequestShipment}
                                {...register("newDtRequestShipment")} />
                        </td>
                        <th style={{ width: "16.66%" }}>배송방법 <span className="required">*</span></th>
                        <td className="p-4px">
                            <select className="form-select"
                                value={watchUpdateData.newPShipment}
                                {...register("newPShipment")}
                                disabled>  {/* 내부수정: 외부 배송방법 편집 불가 */}
                                {shipmentList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                            </select>
                        </td>
                        {/* 내부수정: 배송방법 택배 고정 
                        <td className="p-4px">
                            <select className="form-select"
                                value={watchUpdateData.newPShipment}
                                {...register("newPShipment")}>
                                {shipmentList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                            </select>
                        </td> */}
                    </tr>
                    <tr>
                        <th>수신자 <span className="required">*</span></th>
                        <td className="p-4px">
                            <div className="d-flex">
                                <input type="text" className="form-control"
                                    value={watchUpdateData.recipientName}
                                    disabled />
                                <button
                                    className="btn btn-info btn_search w-100px ms-5px"
                                    onClick={() => btnSearchRecipient("newLRecipientValue")}
                                >
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                        alt=""
                                    />찾기
                                </button>
                            </div>
                        </td>
                        <th>연락처</th>
                        <td className="p-4px">
                            <input type="text" className="form-control"
                                value={watchUpdateData.recipientMobile}
                                disabled />
                        </td>
                    </tr>
                    <tr>
                        {/*<th>발송지 <span className="required">*</span></th>*/}
                        <th>배송지 (기존 주소 선택)</th>
                        <td className="p-4px" colSpan={3}>
                            <div className="d-flex">
                                <input type="text" className="form-control"
                                    value={watchUpdateData.addressName}
                                    disabled />
                                <button
                                    className="btn btn-info btn_search w-100px ms-5px"
                                    onClick={btnSearchAddress}
                                >
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                        alt=""
                                    />찾기
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>주소1</th>
                        <td className="p-4px">
                            <input type="text" className="form-control"
                                value={watchUpdateData.address1}
                                disabled />
                        </td>
                        <th>주소2</th>
                        <td className="p-4px">
                            <input type="text" className="form-control"
                                value={watchUpdateData.address2}
                                disabled />
                        </td>
                    </tr>
                    <tr>
                        <th>신규 배송지 (새 주소 등록 요청)</th>
                        <td className="p-4px" colSpan={3}>
                            <div className="d-flex">
                                <input type="text"
                                    className="form-control w-150px h-34px"
                                    value={watchUpdateData.customPostcode}
                                    disabled />
                                <DaumPost
                                    onCompleteCallback={(data) => {
                                        setValue("customPostcode", data.zipcode)
                                        setValue("customAddress1", data.address)
                                        // 기존 배송지 초기화
                                        setValue("newLAddressValue", "")
                                        setValue("addressName", "")
                                        setValue("address1", "")
                                        setValue("address2", "")
                                    }}
                                />
                                <input type="text"
                                    className="form-control ms-5px h-34px"
                                    value={watchUpdateData.customAddress1}
                                    disabled />
                            </div>
                            <div className="d-flex mt-6px">
                                <input type="text"
                                    className="form-control h-34px"
                                    placeholder="상세 주소"
                                    value={watchUpdateData.customAddress2}
                                    {...register("customAddress2")} 
                                    disabled={!watchUpdateData.customPostcode && !watchUpdateData.customAddress1} />
                            </div>
                        </td>
                        {/*
                        <td className="p-4px" colSpan={3}>
                            <div className="d-flex">
                                <input type="text"
                                    className="form-control w-150px h-34px"
                                    value={watchUpdateData.customPostcode}
                                    disabled />
                                <input type="text"
                                    className="form-control ms-5px h-34px"
                                    value={watchUpdateData.customAddress1}
                                    disabled />
                            </div>
                            <div className="d-flex mt-6px">
                                <input type="text"
                                    className="form-control h-34px"
                                    value={watchUpdateData.customAddress2}
                                    disabled />
                            </div>
                        </td> */}
                    </tr>
                    <tr>
                        <th>발주 메모</th>
                        <td className="p-4px" colSpan={3}>
                            <input type="text" className="form-control"
                                value={watchUpdateData.customerMemo}
                                {...register("customerMemo")} />
                        </td>
                    </tr>
                    {/*<tr>
                    <th>{menuTitleText}메모</th>
                    <td className="p-4px" colSpan={3}>
                        <input type="text" className="form-control"
                               value={watchUpdateData.memo}
                               {...register("memo")}/>
                    </td>
                </tr>*/}
                    <tr>
                        <th>담당자</th>
                        <td>{pcsDetail.owningUserName}</td>
                        <th>{isPcsDelivery ? "발주 번호" : "납품 번호"}</th>
                        <td>{isPcsDelivery ? pcsDetail.purchaseOrderNo : pcsDetail.shipmentNo}</td>
                    </tr>
                    {isPcsDelivery && <>
                        <tr>
                            <th>출하일자</th>
                            <td>{pcsDetail.newDtShipment}</td>
                        </tr>
                        <tr>
                            <th>송장번호</th>
                            <td><input
                                type="text"
                                className="form-control"
                                value={watch("invoiceNo")}
                                {...register("invoiceNo", { maxLength: 13, })}
                                onInput={(e) => {
                                    const target = e.target as HTMLInputElement;
                                    target.value = target.value.replace(/[^0-9]/g, '').slice(0, 13); // 숫자만 허용 + 13자리 제한
                                }}
                            />
                                <button className="btn btn-info btn_search ms-5px w-90px" onClick={btnSearchTransfer}>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />
                                    배송조회
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <th>납품확인서</th>
                            <td></td>
                        </tr>
                    </>
                    }
                </tbody>
            </table>
        </div>

        <h5 className="subheading mt-20px">지급정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                {/*<tbody>*/}
                {/*<tr>*/}
                {/*    <th style={{width: "16.66%"}}>수금예정일 <span className="required">*</span></th>*/}
                {/*    <td className="p-4px" style={{width: "33.34%"}}>*/}
                {/*        <input type="date"*/}
                {/*               className="form-control"*/}
                {/*               max="9999-12-31"*/}
                {/*               value={watchUpdateData.newDtEstimatedCollection}*/}
                {/*               {...register("newDtEstimatedCollection")}/>*/}
                {/*    </td>*/}
                {/*    <th style={{width: "16.66%"}}>결제방법 <span className="required">*</span></th>*/}
                {/*    <td className="p-4px">*/}
                {/*        <select className="form-select"*/}
                {/*                value={watchUpdateData.newPPayment}*/}
                {/*                {...register("newPPayment")}>*/}
                {/*            {paymentList?.map((el: any) => <option value={el.id}>{el.name}</option>)}*/}
                {/*        </select>*/}
                {/*    </td>*/}
                {/*</tr>*/}
                {/*<tr>*/}
                {/*    <th>계산서담당자 <span className="required">*</span></th>*/}
                {/*    <td className="p-4px">*/}
                {/*        <div className="d-flex">*/}
                {/*            <input type="text" className="form-control"*/}
                {/*                   value={watchUpdateData.taxCharge}*/}
                {/*                   disabled/>*/}
                {/*            <button*/}
                {/*                className="btn btn-info btn_search w-100px ms-5px"*/}
                {/*                onClick={() => btnSearchRecipient("newLInvoiceAgentValue")}>*/}
                {/*                <img*/}
                {/*                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}*/}
                {/*                    alt=""*/}
                {/*                />찾기*/}
                {/*            </button>*/}
                {/*        </div>*/}
                {/*    </td>*/}
                {/*    <th>연락처</th>*/}
                {/*    <td className="p-4px">*/}
                {/*        <input type="text" className="form-control"*/}
                {/*               value={watchUpdateData.taxMobile}*/}
                {/*               disabled/>*/}
                {/*    </td>*/}
                {/*</tr>*/}
                {/*<tr>*/}
                {/*    <th>이메일</th>*/}
                {/*    <td className="p-4px" colSpan={3}>*/}
                {/*        <input type="text" className="form-control"*/}
                {/*               value={watchUpdateData.taxEmail}*/}
                {/*               disabled/>*/}
                {/*    </td>*/}
                {/*</tr>*/}
                {/*</tbody>*/}
                <tbody>
                    <tr>
                        <th style={{ width: "16.66%" }}>지급예정일</th>
                        <td className="p-4px" style={{ width: "33.34%" }}>
                            <input type="date"
                                className="form-control"
                                max="9999-12-31"
                                value={watchUpdateData.newDtEstimatedCollection}
                                {...register("newDtEstimatedCollection")} 
                                disabled={Number(user?.inOutFlag) === 1}
                                />
                        </td>
                        <th style={{ width: "16.66%" }}>계산서담당자 <span className="required">*</span></th>
                        <td className="p-4px">
                            <div className="d-flex">
                                <input type="text" className="form-control"
                                    value={watchUpdateData.taxCharge}
                                    disabled />
                                <button
                                    className="btn btn-info btn_search w-100px ms-5px"
                                    onClick={() => btnSearchRecipient("newLInvoiceAgentValue")}
                                >
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                        alt=""
                                    />찾기
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>연락처</th>
                        <td className="p-4px">
                            <input type="text" className="form-control"
                                value={watchUpdateData.taxMobile}
                                disabled />
                        </td>
                        <th>이메일</th>
                        <td className="p-4px">
                            <input type="text" className="form-control"
                                value={watchUpdateData.taxEmail}
                                disabled />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
}